// Centralized data-testid constants
export const IDS = {
  header: {
    logo: 'header-logo-link',
    navHome: 'nav-link-home',
    navAbout: 'nav-link-about',
    navServices: 'nav-link-services',
    navProjects: 'nav-link-projects',
    navContact: 'nav-link-contact',
    ctaContact: 'header-cta-contact',
    mobileToggle: 'header-mobile-toggle',
  },
  hero: {
    section: 'hero-section',
    heading: 'hero-heading',
    ctaContact: 'hero-cta-contact',
    ctaProjects: 'hero-cta-projects',
  },
  about: { section: 'about-section' },
  services: { section: 'services-section', item: (k) => `service-card-${k}` },
  stats: { section: 'stats-section' },
  departments: { section: 'departments-section' },
  projects: { section: 'projects-section', item: (i) => `project-card-${i}` },
  whyUs: { section: 'why-us-section' },
  testimonials: { section: 'testimonials-section' },
  contact: {
    section: 'contact-section',
    form: 'contact-form',
    name: 'contact-input-name',
    email: 'contact-input-email',
    phone: 'contact-input-phone',
    subject: 'contact-input-subject',
    message: 'contact-input-message',
    submit: 'contact-submit-button',
    success: 'contact-success-alert',
    error: 'contact-error-alert',
  },
  footer: { section: 'footer-section' },
};

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_india-launch-1/artifacts/jutubv77_Logo.jpeg';
